import { x25519 } from "@noble/curves/ed25519.js";
import { randomBytes } from "@noble/hashes/utils.js";

export interface X25519KeyPair {
  publicKey: Uint8Array;
  privateKey: Uint8Array;
}

export interface X25519PublicJwk {
  kty: "OKP";
  crv: "X25519";
  x: string;
}

export function generateX25519KeyPair(): X25519KeyPair {
  const privateKey = randomBytes(32);
  const publicKey = x25519.getPublicKey(privateKey);
  return { publicKey, privateKey };
}

export function x25519SharedSecret(
  privateKey: Uint8Array,
  publicKey: Uint8Array,
): Uint8Array {
  return x25519.getSharedSecret(privateKey, publicKey);
}

export function publicKeyToJwk(publicKey: Uint8Array): X25519PublicJwk {
  return {
    kty: "OKP",
    crv: "X25519",
    x: Buffer.from(publicKey).toString("base64url"),
  };
}

export function publicKeyFromJwk(jwk: X25519PublicJwk): Uint8Array {
  if (jwk.kty !== "OKP" || jwk.crv !== "X25519") {
    throw new Error("invalid_x25519_jwk");
  }
  return Buffer.from(jwk.x, "base64url");
}
